/**
 *
 *  AppBanner (UK version)
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 07/24/2024.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */
import React from "react";

// Hooks
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver/useIntersectionObserver";

// Images
import appBannerIphoneLeft from "./app-banner-iphone-left.png";
import appBannerIphoneLeft2x from "./app-banner-iphone-left@2x.png";
import appBannerIphoneLeft3x from "./app-banner-iphone-left@3x.png";
import appBannerIphoneCenter from "./app-banner-iphone-center.png";
import appBannerIphoneCenter2x from "./app-banner-iphone-center@2x.png";
import appBannerIphoneCenter3x from "./app-banner-iphone-center@3x.png";
import appBannerIphoneRight from "./app-banner-iphone-right.png";
import appBannerIphoneRight2x from "./app-banner-iphone-right@2x.png";
import appBannerIphoneRight3x from "./app-banner-iphone-right@3x.png";
import appStoreBtn from "./app-store-btn.svg";

export const AppBanner = () => {
  // Lazy loading by intersection observer!
  const { ref, inView } = useIntersectionObserver(
    {
      triggerOnce: true,
      threshold: 0.1,
      rootMargin: "500px 0px 200px 0px",
    },
    []
  );

  return (
    <div ref={ref} className="tbk-bg-black-grey tbk-bg-become-a-member-hero">
      {inView && (
        <div className="tbk-container tbk-mx-auto tbk-px-3 lg:tbk-px-8">
          <div className="tbk-relative tbk-flex tbk-flex-col lg:tbk-grid lg:tbk-grid-cols-become-member-hero-layout lg:tbk-gap-6 lg:tbk-gap-8">
            <div className="tbk-mb-7 tbk-mt-7">
              <div className="tbk-text-title-bold lg:tbk-text-h2-black tbk-mb-2 tbk-text-basic-white">
                Download <span className="tbk-text-coral">the App</span>
              </div>
              <div className="tbk-text-main lg:tbk-text-title-medium tbk-mb-4 tbk-text-basic-white lg:tbk-mb-3">
                Our seamless booking platform
                <br />
                guarantees ease and accessibility.
                <br />
              </div>
              <a
                className=""
                href="https://apps.apple.com/us/app/trube/id6449003944"
                target="_blank"
              >
                <img src={appStoreBtn} alt="Download on the App Store" />
              </a>
            </div>
            <div className="tbk-flex lg:tbk-self-end">
              <div className="tbk-mr-2">
                <img
                  alt="Find the best personal trainers near me"
                  src={appBannerIphoneLeft}
                  srcSet={`${appBannerIphoneLeft} 1x, ${appBannerIphoneLeft2x} 2x, ${appBannerIphoneLeft3x} 3x`}
                />
              </div>
              <div className="tbk-mr-2">
                <img
                  alt="Find the best personal trainers near me"
                  src={appBannerIphoneCenter}
                  srcSet={`${appBannerIphoneCenter} 1x, ${appBannerIphoneCenter2x} 2x, ${appBannerIphoneCenter3x} 3x`}
                />
              </div>
              <div className="">
                <img
                  alt="Find the best personal trainers near me"
                  src={appBannerIphoneRight}
                  srcSet={`${appBannerIphoneRight} 1x, ${appBannerIphoneRight2x} 2x, ${appBannerIphoneRight3x} 3x`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppBanner;
